import React from "react"
import { useNavigate } from "react-router-dom"
import {
    HeaderContainer,
    BackButtonContainer,
    BackButtonText,
    PageTitle,
    Spacer,
} from "QuorumGrassroots/widgets/ReusableComponents/CampaignSubpageHeader/styles"

interface CampaignSubpageHeaderProps {
    title: string
    backUrl?: string
    dataCy?: string
}

export const CampaignSubpageHeader: React.FC<CampaignSubpageHeaderProps> = ({ title, backUrl, dataCy }) => {
    const navigate = useNavigate()

    const handleBackClick = () => {
        if (backUrl) {
            navigate(backUrl)
        } else {
            navigate(-1)
        }
    }

    const handleBackKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            e.stopPropagation()
            handleBackClick()
        }
    }

    const handleBackKeyUp = (e: React.KeyboardEvent<HTMLButtonElement>) => {
        // Prevent native click on keyup after manual activation above
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            e.stopPropagation()
        }
    }

    return (
        <HeaderContainer data-cy={dataCy}>
            <BackButtonContainer
                type="button"
                onClick={handleBackClick}
                onKeyDown={handleBackKeyDown}
                onKeyUp={handleBackKeyUp}
                aria-label="Go back"
                data-cy={`${dataCy}-back-button`}
            >
                <i className="fa fa-arrow-left" aria-hidden="true" />
                <BackButtonText>Back</BackButtonText>
            </BackButtonContainer>
            <PageTitle>{title}</PageTitle>
            <Spacer />
        </HeaderContainer>
    )
}
